// extracted by mini-css-extract-plugin
module.exports = {"spinner":"LrvModal_spinner__Quz6V","lrvModal":"LrvModal_lrvModal__ilekR","lightModal":"LrvModal_lightModal__1OF9F","darkModal":"LrvModal_darkModal__TZp2k"};